<template>
  <v-container fluid class="pa-5">
    <v-overlay :value="isLoading" absolute>
      <div class="d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate size="64" :width="5" />
        <span class="my-4">กำลังโหลดข้อมูล</span>
      </div>
    </v-overlay>

    <template v-if="!isLoading">
      
      <template>
        <v-card class="card-container pa-2" elevation="0">
          <v-card-title>
            <v-row>
              <v-col
                cols="12"
                md="6"
                class="d-flex align-center justify-center justify-md-start"
              >
                <span class="title-text">จัดการบริษัทขนส่ง</span>
              </v-col>

              <v-col
                cols="12"
                md="6"
                class="d-flex align-center justify-center justify-md-end"
              >
                <v-btn
                  color="#F4811F"
                  dark
                  class="create-btn elevation-0"
                  @click="openCreate"
                >
                  <v-icon left size="24">mdi-plus</v-icon>
                  เพิ่มบริษัทขนส่ง
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="4" class="d-flex align-end px-2">
                <v-text-field
                  v-model="search"
                  placeholder="ค้นหาจากชื่อบริษัท / CODE / ผู้ติดต่อ"
                  hide-details
                  outlined
                  dense
                  class="rounded-lg"
                  clearable
                >
                  <template v-slot:append>
                    <v-img
                      src="@/assets/select/search_icon.png"
                      width="16"
                      height="16"
                      class="mt-1"
                      contain
                    />
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="12" md="3" class="px-2">
                <span class="title-select-text">สถานะการใช้งาน</span>
                <v-select
                  v-model="selectedStatus"
                  :items="statusItems"
                  :menu-props="{ offsetY: true }"
                  placeholder="ทั้งหมด"
                  hide-details
                  outlined
                  dense
                  class="rounded-lg"
                  item-text="text"
                  item-value="value"
                >
                  <template v-slot:append>
                    <v-img
                      src="@/assets/select/expand_icon.png"
                      width="16"
                      height="16"
                      contain
                      class="icon-rotate mt-1"
                    />
                  </template>
                </v-select>
              </v-col>

              <v-col cols="12" md="2" class="d-flex justify-start align-end px-2">
                <span
                  class="clear-btn-text mb-2"
                  style="color: #F4811F; cursor: pointer"
                  @click="clearFilters"
                >
                  ล้างค่า
                </span>
              </v-col>

              <v-col cols="12">
                <span class="count-data-text">
                  บริษัทขนส่ง ทั้งหมด {{ filteredCompanies.length }} รายการ
                </span>
              </v-col>

              <v-col cols="12">
                <template v-if="filteredCompanies.length > 0">
                  <AdminVehicleTypesTable
                    :items="filteredCompanies"
                    @edit="openEdit"
                  />
                </template>

                <template v-else>
                  <v-row>
                    <v-col
                      cols="12"
                      class="d-flex flex-column align-center justify-center"
                      style="min-height: 45vh"
                    >
                      <div class="d-flex flex-column align-center">
                        <v-img>
                          <img
                            src="@/assets/not_exist_search.svg"
                            alt="no-data"
                            width="103.8"
                            height="103.8"
                          />
                        </v-img>
                        <span class="no-data-text mb-4">
                          ไม่พบข้อมูลที่ค้นหา กรุณาลองใหม่อีกครั้ง
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>

            <AdminVehicleTypeDialog
              v-model="dialogVisible"
              :item="selectedItem"
              :loading="dialogLoading"
              @save="handleSave"
            />
          </v-card-text>
        </v-card>
      </template>
    </template>
  </v-container>
</template>

<script>
import AdminVehicleTypesTable from "@/components/AdminVehicleTypes/Table.vue";
import AdminVehicleTypeDialog from "@/components/AdminVehicleTypes/Dialog.vue";
import {
  getShippingCompaniesApi,
  createVehicleTypeApi,
  updateVehicleTypeApi,
} from "@/services/api/adminServices";
import swalAlert from "@/services/alert/swalServices";

export default {
  name: "AdminVehicleTypes",

  components: {
    AdminVehicleTypesTable,
    AdminVehicleTypeDialog,
  },

  data() {
    return {
      isLoading: false,
      companies: [],
      search: "",
      selectedStatus: "all",
      dialogVisible: false,
      dialogLoading: false,
      selectedItem: null,
      statusItems: [
        { text: "ทั้งหมด", value: "all" },
        { text: "เปิดใช้งาน", value: "active" },
        { text: "ปิดใช้งาน", value: "inactive" },
      ],
    };
  },

  computed: {
    filteredCompanies() {
      let result = [...this.companies];

      if (this.selectedStatus && this.selectedStatus !== "all") {
        const target = this.selectedStatus.toLowerCase();
        result = result.filter(
          (c) => (c.status || "").toString().toLowerCase() === target
        );
      }

      if ((this.search || "").trim()) {
        const kw = this.search.toLowerCase().trim();
        result = result.filter((c) => {
          const name = (c.name || "").toLowerCase();
          const code = (c.code || "").toLowerCase();
          const contact = (c.contactName || "").toLowerCase();
          const phone = (c.phone || "").toLowerCase();
          return (
            name.includes(kw) ||
            code.includes(kw) ||
            contact.includes(kw) ||
            phone.includes(kw)
          );
        });
      }

      return result;
    },
  },

  async created() {
    await this.loadCompanies();
  },

  methods: {
    async loadCompanies() {
      this.isLoading = true;
      try {
        const data = await getShippingCompaniesApi();
        // รองรับทั้ง { data: [...] } หรือ array ตรง ๆ
        if (Array.isArray(data)) {
          this.companies = data;
        } else if (Array.isArray(data.data)) {
          this.companies = data.data;
        } else if (Array.isArray(data.items)) {
          this.companies = data.items;
        } else {
          this.companies = [];
        }
      } catch (err) {
        console.error("[AdminVehicleTypes] loadCompanies error:", err);
        this.companies = [];
        swalAlert.Error(
          "โหลดข้อมูลไม่สำเร็จ",
          err?.response?.data?.message || "ไม่สามารถโหลดข้อมูลบริษัทขนส่งได้"
        );
      } finally {
        this.isLoading = false;
      }
    },

    clearFilters() {
      this.search = "";
      this.selectedStatus = "all";
    },

    openCreate() {
      this.selectedItem = null;
      this.dialogVisible = true;
    },

    openEdit(item) {
      this.selectedItem = item;
      this.dialogVisible = true;
    },

    async handleSave(payload) {
      this.dialogLoading = true;
      try {
        if (payload.id) {
          const res = await updateVehicleTypeApi(payload.id, payload);
          const updated = res.company || res.data || payload;
          this.companies = this.companies.map((c) =>
            (c.id || c._id) === (updated.id || updated._id) ? { ...c, ...updated } : c
          );
          await swalAlert.Success("บันทึกการแก้ไขบริษัทขนส่งสำเร็จ");
        } else {
          const res = await createVehicleTypeApi(payload);
          const created = res.company || res.data || res;
          this.companies = [created, ...this.companies];
          await swalAlert.Success("เพิ่มบริษัทขนส่งสำเร็จ");
        }

        this.dialogVisible = false;
      } catch (err) {
        console.error("[AdminVehicleTypes] save error:", err);
        swalAlert.Error(
          "บันทึกข้อมูลไม่สำเร็จ",
          err?.response?.data?.message || "ไม่สามารถบันทึกข้อมูลบริษัทขนส่งได้"
        );
      } finally {
        this.dialogLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.title-text {
  font-size: 24px;
  font-weight: 700;
  color: #1f2a39;
}

.no-data-text {
  font-size: 14px;
  font-weight: 400;
  color: #6b717f;
}

.card-container {
  border-radius: 16px !important;
  box-shadow: 0 0 2px 0 #1018280d !important;
}

.count-data-text {
  font-size: 16px;
  font-weight: 600;
  color: #394253;
}

.create-btn {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  height: 40px !important;
  text-transform: none !important;
}

.title-select-text {
  font-size: 16px;
  font-weight: 400;
  color: #1f2a39;
}

.clear-btn-text {
  font-size: 14px;
  font-weight: 400;
}

.v-text-field--outlined >>> fieldset,
.v-select--outlined >>> fieldset {
  border-color: #e5e7eb !important;
  border-radius: 8px !important;
}

.v-select .icon-rotate {
  transition: transform 0.3s ease;
  transform: rotate(0deg);
}

.v-select.v-select--is-menu-active .icon-rotate {
  transform: rotate(180deg);
}

::v-deep(.v-select__selections),
::v-deep(.v-text-field__slot),
::v-deep(.v-label) {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #1f2a39 !important;
}
</style>

